import React from "react";
import "./Hero2.css";

const Hero2 = () => {
  return (
    <div className="hero2-wrapper">
      <img
        src="/assets/images/About_page/Vector.png"
        alt="Background"
        className="hero2-background-img"
      />
      <div className="hero2-container">
        <div className="hero2-content">
          <h1 className="hero2-title">Unlocking Business Value with Precision and Purpose</h1>
          <h2 className="hero2-subtitle">Empowering Decisions with Smart Valuation Tools</h2>
          <p className="hero2-description">
            At Clybourne, we bridge technology and expertise to deliver
            transparent, data-driven business valuations. Whether you're scaling,
            seeking investment, or planning for a future sale, our platform equips
            you with actionable insights to drive confident decisions.
          </p>
          <div className="hero-buttons">
              <button className="btn-pri">Let’s Talk!</button>
              <button className="btn-secondary">Buy Now</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero2;
